const API = process.env.REACT_APP_BACKEND_URL;
const ATTR_KEY = "pepmuse_attr";
const SKIP_PREFIXES = ["/admin", "/account", "/reset-password"];

export function captureAttribution() {
  if (sessionStorage.getItem(ATTR_KEY)) return;
  const params = new URLSearchParams(window.location.search);
  const attr = {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    referrer: document.referrer || "",
    landing_page: window.location.pathname,
  };
  try {
    sessionStorage.setItem(ATTR_KEY, JSON.stringify(attr));
  } catch {
    /* storage unavailable */
  }
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(ATTR_KEY)) || {};
  } catch {
    return {};
  }
}

export function trackPageview(path) {
  if (SKIP_PREFIXES.some((p) => path.startsWith(p))) return;
  const attr = getAttribution();
  fetch(`${API}/api/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path, ...attr }),
  }).catch(() => {});
}

// --- Google Analytics 4 (gtag.js, loaded only when a Measurement ID is configured) ---
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let gaInitStarted = false;

function ensureGa() {
  if (!GA_ID || typeof window === "undefined") return;
  if (window.gtag) return;
  if (gaInitStarted) return;
  gaInitStarted = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

export function trackGaPageview(path) {
  if (!GA_ID) return;
  if (SKIP_PREFIXES.some((p) => path.startsWith(p))) return;
  ensureGa();
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: path,
    send_to: GA_ID,
  });
}

export function trackGaEvent(name, params = {}) {
  if (!GA_ID) return;
  ensureGa();
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
